import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.notifications.loaded,
    props.notifications.opened,
    props.notifications.has_unread,
    props.notifications.notifications,
    (loaded, opened, has_unread, notifications) => {
        return {
            loaded,
            opened,
            has_unread,
            notifications
        }
    }
)